import React from 'react';
import { Button } from './Button';
export const HowItWorksSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS';
  return <section className="bg-gradient-to-b from-teal-800 to-teal-900 text-white py-16" data-id="element-173">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-174">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-175">
          How It Works
        </h2>
        <div className="grid md:grid-cols-2 gap-8 mb-10" data-id="element-176">
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-177">
            <h3 className="text-xl font-bold mb-3" data-id="element-178">
              30 Days of Guided Somatic Reset
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-179">
              <li data-id="element-180">Follow at your own pace</li>
              <li data-id="element-181">Every day includes a 10–20 minute guided practice</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-182">
            <h3 className="text-xl font-bold mb-3" data-id="element-183">
              Lifetime Access to All Content
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-184">
              <li data-id="element-185">Revisit your favorite tools any time</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-186">
            <h3 className="text-xl font-bold mb-3" data-id="element-187">
              Evidence-Based, Therapist-Led
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-188">
              <li data-id="element-189">Created by a Doctor of Behavioral Health & Somatic Expert</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-190">
            <h3 className="text-xl font-bold mb-3" data-id="element-191">
              Bonus: Deep-Dive Video Lessons
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-192">
              <li data-id="element-193">Learn how trauma wires the body and how to rewire it</li>
            </ul>
          </div>
        </div>
        <div className="flex justify-center" data-id="element-194">
          <Button link={checkoutUrl} data-id="element-195">Get Started Now ➔</Button>
        </div>
      </div>
    </section>;
};